class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
    this.mainDetailsToggle.addEventListener("click", this.onToggle.bind(this));
  }

  onToggle(e){
    if (!e.target.matches("a") && !e.target.closest("a") ) {
      e.preventDefault()
    }

    if (this.mainDetailsToggle.open) {
      this.mainDetailsToggle.classList.add('details-opening');
      this.adjustOverlay();
    } else {
      this.mainDetailsToggle.classList.remove('details-opening');
    }
  }


  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
  }

  adjustOverlay() {
    if (!this.closest('header')) return false;
    const headerOverlay = document.querySelector('.js-header-overlay');
    if (this.hasAttribute('data-disable-overlay')) {
      headerOverlay.classList.add('hidden')
      headerOverlay.style.height = '0px';
    } else {
      headerOverlay.classList.remove('hidden')
      const sourceElement = this.querySelector('.js-details-disclosure-smooth-element');
      if (headerOverlay && sourceElement) {
        const height = sourceElement.scrollHeight;
        headerOverlay.style.height = height + 'px';
      }
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
